import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/admin/page.tsx");
